/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Quota_Notice_IncludedInputs */

const fr_calendar_quota_notice_included = /** @type {(inputs: Calendar_Quota_Notice_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune séance utilisée — ce cours est inclus dans la même journée`)
};

/**

* @param {Calendar_Quota_Notice_IncludedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_quota_notice_included = /** @type {((inputs?: Calendar_Quota_Notice_IncludedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Quota_Notice_IncludedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_quota_notice_included(inputs)
});